import { makeAutoObservable } from "mobx"

export default class Post {

  constructor(post={}) {
    this.id = post.id
    this.authentication_id = post.authentication_id
    this.uid = post.uid
    this.post_type = post.post_type
    this.provider = post.provider
    this.text = post.text || ''
    this.comments_count = post.comments_count || 0
    this.likes_count = post.likes_count || 0
    this.views_count = post.views_count || 0
    this.shares_count = post.shares_count || 0
    this.posted_at = post.posted_at || ''
    this.url = post.url || ''
    this.thumbnail = post.thumbnail
    this.shortcode = post.shortcode || ''
    this.sponsored = !!post.sponsored
    this.brands = post.brands || []
    this.authentication = post.authentication || null

    makeAutoObservable(this)
  }
}
